import React from "react";
import { cn } from "@/utils/tailwind-utils";
import styles from "./MSkeleton.module.css";

interface MSkeletonProps {
  className?: string;
}

/** A shimmering placeholder block used while section data is still loading. */
const MSkeleton: React.FC<MSkeletonProps> = ({ className }) => (
  <div className={cn(styles.shimmer, "rounded-xl", className)} />
);

export default MSkeleton;
